import type { IScrLine } from '@/interfaces'

export class ScrLine implements IScrLine {
	notes?: string
	scrId?: number
	lineId?: number
	lineOrder?: number
	item?: string
	itemRev?: string
	workOrderId?: number
	workOrderLineId?: number
	createBy?: number
	updateBy?: number
	createDatetime?: Date
	updateDatetime?: Date
	approveDatetime?: Date
	rejectDatetime?: Date
	approveDatetimeFin?: Date
	rejectDatetimeFin?: Date
	rejectReason?: string
	approveDatetimeOps?: Date
	rejectDatetimeOps?: Date
	approveByFin?: number
	rejectByFin?: number
	approveByOps?: number
	rejectByOps?: number
	priceAtSCR?: number
	descriptionAtSCR?: string
	description?: string
	price?: number

	constructor({
		notes,
		scrId,
		lineId,
		lineOrder,
		item,
		itemRev,
		workOrderId,
		workOrderLineId,
		createBy,
		updateBy,
		createDatetime,
		updateDatetime,
		approveDatetime,
		rejectDatetime,
		approveDatetimeFin,
		rejectDatetimeFin,
		rejectReason,
		approveDatetimeOps,
		rejectDatetimeOps,
		approveByFin,
		rejectByFin,
		approveByOps,
		rejectByOps,
		priceAtSCR,
		descriptionAtSCR,
		description,
		price
	}: Partial<IScrLine> = {}) {
		this.notes = notes
		this.scrId = scrId
		this.lineId = lineId
		this.lineOrder = lineOrder
		this.item = item
		this.itemRev = itemRev
		this.workOrderId = workOrderId
		this.workOrderLineId = workOrderLineId
		this.createBy = createBy
		this.updateBy = updateBy
		this.createDatetime = createDatetime
		this.updateDatetime = updateDatetime
		this.approveDatetime = approveDatetime
		this.rejectDatetime = rejectDatetime
		this.approveDatetimeFin = approveDatetimeFin
		this.rejectDatetimeFin = rejectDatetimeFin
		this.rejectReason = rejectReason
		this.approveDatetimeOps = approveDatetimeOps
		this.rejectDatetimeOps = rejectDatetimeOps
		this.approveByFin = approveByFin
		this.rejectByFin = rejectByFin
		this.approveByOps = approveByOps
		this.rejectByOps = rejectByOps
		this.priceAtSCR = priceAtSCR
		this.descriptionAtSCR = descriptionAtSCR
		this.description = description
		this.price = price
	}
}
